<section>
  <app-auth-template
    title="User Verifizierung"
    [description]="getDescription()"
  >
    <app-button
      [fullWidth]="true"
      [isLoading]="requestState() === RequestStateEnum.PENDING"
      [disabled]="requestState() !== RequestStateEnum.SUCCESS"
      variant="primary"
      text="Zum Login"
      (click)="onClick()"
    />
  </app-auth-template>
</section>
